;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { SellerCurrency } from '@qogita/canary-client'

type GetIntlNumberFormatForCurrency = (
  locale: string,
  currency: SellerCurrency,
  exponent?: number,
) => Intl.NumberFormat
type GetFormattedCurrency = (
  value: number,
  locale: string,
  exponent?: number,
) => string
type GetFormattedCurrencyWithSymbol = (
  value: number,
  currency?: SellerCurrency,
  exponent?: number,
  locale?: string,
) => string

/**
 * @param locale A locale.
 * @param currency A currency.
 * @param exponent The exponent. Default: 2.
 * @returns An instance of Intl.NumberFormat configured for currency.
 */
const getIntlNumberFormatForCurrency: GetIntlNumberFormatForCurrency = (
  locale,
  currency,
  exponent = 2,
) => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    signDisplay: 'auto',
    currencyDisplay: 'narrowSymbol',
    currencySign: 'standard',
    minimumIntegerDigits: 1,
    minimumFractionDigits: exponent,
    maximumFractionDigits: exponent,
  })
}

/**
 * @param value The amount to be formatted.
 * @param locale A locale.
 * @param exponent The exponent. Default: 2.
 * @returns A locale-sensitive currency string of a given number.
 */
export const getFormattedCurrency: GetFormattedCurrency = (
  value,
  locale,
  exponent = 2,
) => {
  return getIntlNumberFormatForCurrency(locale, 'EUR', exponent)
    .formatToParts(value)
    .filter((part) =>
      ['integer', 'group', 'decimal', 'fraction'].includes(part.type),
    )
    .map((part) => part.value)
    .join('')
}

/**
 * @param value The amount to be formatted.
 * @option currency A currency.
 * @option locale A locale.
 * @option exponent The exponent. Default: 2.
 * @returns A locale-sensitive currency string of a given number.
 */
export const getFormattedCurrencyWithSymbol: GetFormattedCurrencyWithSymbol = (
  value,
  currency = 'EUR',
  exponent = 2,
  locale = 'en-GB',
) => {
  return getIntlNumberFormatForCurrency(locale, currency, exponent).format(
    value,
  )
}

export const getCurrencySymbol = (currency: SellerCurrency) => {
  if (!currency) return ''
  return getIntlNumberFormatForCurrency('en-GB', currency).format(0).slice(0, 1)
}
